import { Component, OnInit } from '@angular/core';
import { ViewService } from '@services/view.service';
import { AddService } from '@services/add.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CommonPipe } from '@pipes/common.pipe';
import * as _ from 'lodash';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-vproduct',
  templateUrl: './vproduct.component.html',
  styleUrls: ['./vproduct.component.sass'],
  animations: [
    fadeInLeftOnEnterAnimation({ anchor: 'fadeInLeft' })
  ]
})
export class VproductComponent implements OnInit {
  application = "product";
  page_load = true;
  qty = "1";
  component = '';
  is_owner = false;
  rate = 0;
  currency = "";
  params: any = [];
  reviews: any = [];
  id = "";
  response: any = [];
  weekday: any = [];
  hours_start: any = [];
  rate_readonly = false;
  hours_end: any = [];
  tag: any = [];
  category: any = [];
  review_count = 0;
  images: any = [];
  isLogin = false;
  btn_process = false;
  show = { review: true, qa: false }
  constructor(private router: Router, private _commonPipe: CommonPipe, private _addService: AddService, private route: ActivatedRoute, private _viewService: ViewService, private _global: GlobalService) {

    
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.currency = this._global.getCurrency().toLowerCase();
    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }

    this.weekday = this._global.BUSINESS_WEEKDAY;
    this.hours_start = this._global.BUSINESS_HOURS_START;
    this.hours_end = this._global.BUSINESS_HOURS_END;
    let pa=this._global.getAppViewParam(this.route.snapshot.url[1].path);
    this.component=pa.c;
    this.id=pa.id;
      let p = {
        'component': this.component,
        'application': this.application,
        'id': this.id
      };
      this._viewService.application(p).subscribe(
        data => {

          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.page_load = false;
            this.response = this._global.getVal(data, 'response', '');
            if (this._global.getVal(this.response, 'tag', '')) {
              this.tag = this._global.getVal(this.response, 'tag', '').split(",");
            }
            if (this._global.getVal(this.response, 'category', '')) {
              this.category = this._global.getVal(this.response, 'category', '').split("|");
            }
            this.is_owner = this._global.isOwner(this._global.getVal(this.response, 'createdBy', ''));
            this.images.push(this._commonPipe.transform(this.response, ['image', this.application, 'id', 'name', 'l']));
            this._global.addMetaInfo(this.response, 'view', 'name');
            this.rate = this._global.getVal(this.response, 'rating', '');

          }else{
            this.router.navigate(['']);
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
          this.router.navigate(['']);
        });
  }
  ngOnInit() {

  }

  addtoWishlist() {

    let p = {
      component: this.component,
      application: 'wishlist',
      quantity: 1,
      productId: this.id
    };
    this._addService.application(p).subscribe(
      data => {
        let message = '';
        if (data["status"] == "1") {
          message = this._global.getVal(data, 'message.info', "");
          this._global.showMessage({ "type": 'success', "message": message });
        } else {
          this._global.showMessage({ "type": 'warning', "message": this._global.getVal(data, 'message.error', '') });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  addtoCart() {

    let p = {
      component: this.component,
      application: 'cart',
      quantity: this.qty,
      productId: this.id,
      previousQuantity: 1
    };
    this._addService.application(p).subscribe(
      data => {
        let message = '';
        if (data["status"] == "1") {
          message = this._global.getVal(data, 'message.info', "");
          this._global.showMessage({ "type": 'success', "message": message });
        } else {
          this._global.showMessage({ "type": 'warning', "message": this._global.getVal(data, 'message.error', '') });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }


  edit() {
    this.router.navigate(['/edit/' + this.application], { queryParams: { 'id': this.id } });
  }
  showTab(tab){
    this.visible(tab);
  }
  visible(template) {
    Object.entries(this.show).forEach(([key, value]) => {
      if (template == key) {
        this.show[key] = true;
      } else {
        this.show[key] = false;
      }
    });
  }
}
